module.exports = __webpack_public_path__ + "img/Patch_Notes-Normal.98e3c4f1.webp";